module.exports = "<div class=\"open-popup o-btn\" @click=\"openPopup()\">\n\t{{ $t( translationString ) }}\n</div>"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/components/open-popup/open-popup.vhtml
// module id = 297
// module chunks = 0